import { createAction } from "redux-actions";

export const getLanguages = createAction("GET_LANGUAGES");
export const setLanguages = createAction("SET_LANGUAGES");
